<div class="normalScreen" style="background:white">
  <form [formGroup]="searchForm" (ngSubmit)="search()">
    <div style="margin-left:10px;margin-top:10px">

      <mat-form-field>
        <input matInput data-cy="startDateInput"
        [matDatepicker]="startPicker"
        [max]="maxDate"
        placeholder="Startdatum"
        formControlName="startDate">
        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="mat-form-field-time">
        <input class="timeInput"  data-cy="startTimeInput" type="time" matInput formControlName="startTime">
      </mat-form-field>

      <mat-form-field>
        <input matInput data-cy="endDateInput"
        [matDatepicker]="endPicker"
        [min]="startDateInput.value"
        [max]="maxDate"
        value="startDateInput.value"
        placeholder="Slutdatum"
        formControlName="endDate">
        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="mat-form-field-time">
        <input class="timeInput" matInput data-cy="endTimeInput" type="time" formControlName="endTime" >
      </mat-form-field>
    </div>

    <div>
      <button mat-flat-button color="primary" data-cy="searchCheckins" type="submit"
        style="margin-left:10px;background:#7AB800" [disabled]="!canSearch()">Sök</button>
    </div>

  </form>
  <div style="margin-left:10px;margin-top:10px" *ngIf="noMatch" class="alert alert-info">
    <label>Hittade inga matchande incheckningar.</label>
  </div>
  <div>
    <ngx-spinner #spinner [config]="spinnerConfig">
    </ngx-spinner>

    <mat-table #table [dataSource]="dataSource" matSort matSortDisableClear="true" class="mat-elevation-z0">
    <mat-header-row style="background-color:white; position: sticky; z-index: 90;" *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Namn </mat-header-cell>
      <mat-cell *matCellDef="let element">{{element.name}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="checkInAsLocalDateString">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Incheckad </mat-header-cell>
      <mat-cell *matCellDef="let element">{{element.checkInAsLocalDateString}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="checkOutAsLocalDateString">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Utcheckad </mat-header-cell>
      <mat-cell *matCellDef="let element">{{element.checkOutAsLocalDateString}}</mat-cell>
    </ng-container>

    </mat-table>
  </div>
</div>
